import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import relativeTime from 'dayjs/plugin/relativeTime';
import App from './App';
import './shared/styles/global.css';

// dayjs 전역 설정
dayjs.extend(relativeTime);
dayjs.locale('ko');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
